import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function LanguageToggle() {
  const {
    language,
    setLanguage
  } = useLanguage();
  return <div className="flex items-center bg-darkGray rounded-full p-1 border border-gray-700 shadow-inner" data-id="element-101">
      <button onClick={() => setLanguage('en')} className={`px-3 py-1 text-xs font-bold rounded-full transition-all duration-300 ${language === 'en' ? 'bg-gold text-navy shadow-md' : 'text-gray-400 hover:text-white'}`} data-id="element-102">
        EN
      </button>
      <button onClick={() => setLanguage('es')} className={`px-3 py-1 text-xs font-bold rounded-full transition-all duration-300 ${language === 'es' ? 'bg-gold text-navy shadow-md' : 'text-gray-400 hover:text-white'}`} data-id="element-103">
        ES
      </button>
    </div>;
}